import React, { Component } from "react";
import "./App.css";
import Layout from "./components/Layout/Layout";
import ProjectOverview from "./containers/Overview/ProjectOverview";
import AgencyOverview from "./containers/Overview/AgencyOverview";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import Header from "./components/Header";
import Login from "./components/Login";
import LegislationOverview from "./containers/Overview/LegislationOverview";
import AdminOverview from "./containers/Overview/AdminOverview";
import OrganizationOverview from "./containers/Overview/OrganizationOverview";
import ProfileOverview from "./containers/Overview/ProfileOverview";
import DataLoggingOverview from "./containers/Overview/DataLoggingOverview";
import { Container } from "reactstrap";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let roles = JSON.parse(localStorage.getItem("role"));
let project_role;
if (roles) {
  if (roles.some(role => role.name === "ROLE_MEMBER")) {
    project_role = "ROLE_MEMBER";
  } else if (roles.some(role => role.name === "ROLE_AUDITOR")) {
    project_role = "ROLE_AUDITOR";
  } else if (roles.some(role => role.name === "ROLE_USER")) {
    project_role = "ROLE_USER";
  }
  localStorage.setItem("project_role", project_role);
}
//localStorage.getItem("token")
class App extends Component {
  PrivateRoute({ component: Component }) {
    return (
      <Route
        render={props =>
          cookies.get("token") !==undefined ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/login" }} />
          )
        }
      />
    );
  }
  LoginRoute({ component: Component }) {
    return (
      <Route
        render={props =>
          cookies.get("token") !==undefined ? (
            <Redirect to={{ pathname: "/project" }} />
          ) : (
            <Component {...props} />
          )
        }
      />
    );
  }
  render() {
    let routes = (
      <Switch>
        <this.PrivateRoute
          path="/legislation"
          component={LegislationOverview}
        />
        <this.PrivateRoute path="/project" component={ProjectOverview} />
        <this.PrivateRoute path="/agency" component={AgencyOverview} />
        <this.PrivateRoute path="/admin" component={AdminOverview} />
        <this.PrivateRoute path="/logging" component={DataLoggingOverview} />
        <this.PrivateRoute
          path="/organization"
          component={OrganizationOverview}
        />
        <this.PrivateRoute path="/profile" component={ProfileOverview}/>
        <this.LoginRoute path="/login" component={Login} />
        <Route path="/" render={() => <Redirect to="/project" />} />
      </Switch>
    );

    return (
      <div>
        <Header />
        <Container fluid className="my-2">
          <div className="mx-5">{routes}</div>
          <Layout />
        </Container>
      </div>
    );
  }
}

export default withRouter(App);
